import React from 'react'
import {
    Button, Container,
    Row, Col, Label, Input,
    Table,
} from 'reactstrap'
import {
    IMPERFECTIONS,
    getPlatesFromJob,
    updatePlate,
} from '../model/request/machine'
import dateFormat from 'dateformat'

function expected_end_time(machine) {
  if (machine.end_time) {
    return machine.end_time;
  } else {
    return machine.start_time + machine.expected_time;
  }
}

function findToolInMachine(machine, toolNumber) {
    return machine.tool_info.find((tool) => tool.tool_number == toolNumber)
}

function compareStrings(a, b) {
    while (a.length > 0 && b.length > 0) {
        let aNumb = Number.parseInt(a)
        let bNumb = Number.parseInt(b)

        if (!isNaN(aNumb) && !isNaN(bNumb)) {
            if (aNumb !== bNumb) {
                return aNumb - bNumb
            }
            a = a.substr(("" + aNumb).length)
            b = b.substr(("" + bNumb).length)
        } else if (!isNaN(aNumb)) {
            return -1
        } else if (!isNaN(bNumb)) {
            return 1
        } else {
            if (a[0] < b[0]) {
                return 1
            } else if (a[0] > b[0]) {
                return -1
            } else {
                a = a.substr(1)
                b = b.substr(1)
            }
        }
    }

    return a.length - b.length
}

function values(plates) {
    let price = 0.0
    let time = 0
    for (let i = 0; i < plates.length; i++) {
        let minutes = (plates[i].end_time - plates[i].start_time) / 60
        let value = plates[i].height * plates[i].width * 0.3
        if (minutes > 5 && minutes < 24 * 60 && value > 3.0) {
            price += value
            time += minutes
        }
    }

    return {
        'totalPrice': price,
        'time': time,
        'averagePrice': price / time
    }
}

class ImperfectionAdderViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
            'plates': [],
            'tool_numbers': [],
            'job_name': '',
        }
    }

    search() {
        this.props.turnOnLoader()
        getPlatesFromJob(this.state.job_name.toLowerCase()).then(
            (result) => {
                this.setState({
                    'plates': result.sort((a, b) => {
                        const weeklyA = Number.parseInt(a.start_time / (60 * 60 * 24 * 7))
                        const weeklyB = Number.parseInt(a.start_time / (60 * 60 * 24 * 7))

                        if (weeklyA !== weeklyB) {
                            return weeklyA - weeklyB
                        }

                        const value = compareStrings(a.file_name, b.file_name)
                        return value
                    }),
                    'tool_numbers': [...new Set(
                        result.map((item) => item.tool_info.map(
                            (item) => item.tool_number
                        )).flat())
                    ].sort((a, b) => {
                        return Number.parseInt(a) - Number.parseInt(b);
                    }),
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    updatePlates() {
        this.props.turnOnLoader(this.state.plates.length)
        for (let i = 0; i < this.state.plates.length; i++) {
            updatePlate(this.state.plates[i]).then(
                (result) => {
                    this.props.turnOffLoader()
                },
                (error) => {
                    this.props.showError(error)
                    this.props.turnOffLoader()
                }
            )
        }
    }

    secondsToDate(seconds) {
      let d = new Date(0);
      d.setUTCSeconds(seconds);
      return d;
    }

    formatSeconds(seconds) {
      return dateFormat(this.secondsToDate(seconds), 'mmmm d, yyyy hh::MM tt')
    }

    makeRows() {
        return this.state.machines.map((machine, index) => {
            return <Col key={"card"+index} lg="3" sm="6">
              <Container>
                <Row><Col><Label
                  style={{
                    'fontSize': '18pt',
                    'fontWeight': '400',
                  }}
                >{machine.machine}</Label></Col></Row>
                {machine.end_time ? "Machine Stopped" : "Is Running"}
                {this.labelAndValue('File', machine.file_name)}
                {this.labelAndValue('Start Time', this.formatSeconds(machine.start_time))}
                {this.labelAndValue('End Time', this.formatSeconds(expected_end_time(machine)))}
              </Container>
            </Col>
        })
    }

    hasMachines() {
      return this.state.latest_index < this.state.machines.length
    }

    latestMachine() {
      return this.state.machines[this.state.latest_index]
    }

    labelAndValue(label, value) {
      return <Col><Container>
        <Row><Col><Label>{label}</Label></Col></Row>
        <Row><Col><Label>{value}</Label></Col></Row>
      </Container></Col>
    }

    checkBox(plate, imperfection) {
        return <Input
            type="checkbox"
            checked={plate.imperfections.indexOf(imperfection) !== -1}
            onClick={() => {
                if (plate.imperfections.indexOf(imperfection) === -1) {
                    plate.imperfections.push(imperfection);
                } else {
                    plate.imperfections = plate.imperfections.filter((imp) => imp !== imperfection)
                }

                this.setState({})
            }}
        />
    }

    makeRows() {
      return this.state.plates.map((machine) => {
        return <tr>
          <td style={{'minWidth': '130px'}}>{machine.file_name}</td>
          {
              IMPERFECTIONS.map((imp) => <td style={{'minWidth': '150px'}}>{this.checkBox(machine, imp.var_name)}</td>)
          }
          <td style={{'minWidth': '150px'}}>{this.formatSeconds(machine.start_time)}</td>
          <td style={{'minWidth': '150px'}}>{machine.machine}</td>
          <td style={{'minWidth': '150px'}}>{machine.operator}</td>
          <td style={{'minWidth': '150px'}}>{Math.ceil((expected_end_time(machine) - machine.start_time) / 60)}</td>
          <td style={{'minWidth': '130px'}}>{machine.humidity}</td>
          <td style={{'minWidth': '130px'}}>{machine.air_quality}</td>
          <td style={{'minWidth': '130px'}}>{machine.pressure}</td>
          <td style={{'minWidth': '130px'}}>{machine.temperature}</td>
          <td style={{'minWidth': '150px'}}>{machine.height}</td>
          <td style={{'minWidth': '150px'}}>{machine.width}</td>
          <td style={{'minWidth': '150px'}}>{machine.version}</td>
          {
              this.state.tool_numbers.map(
                  (toolNumber) => {
                      const tool = findToolInMachine(machine, toolNumber);
                      if (!tool) {
                          return <><td
                            style={{'minWidth': '150px'}}
                          ></td><td
                            style={{'minWidth': '150px'}}
                          ></td></>
                      }

                      return <>
                        <td style={{'minWidth': '150px'}}>
                            {tool.feed_rate}
                        </td>
                        <td style={{'minWidth': '150px'}}>
                            {tool.length}
                        </td>
                      </>
                  }
              )
          }
        </tr>
      })
    }

    render() {
        const v = values(this.state.plates)
        return (
            <Container>
              <Row><Col><Label
                style={{
                  'fontSize': '20pt',
                  'fontWeight': '400',
                }}
              >Job</Label></Col></Row>
              <Row><Col><Input
                type='text'
                value={this.state.job_name}
                onChange={(e) => this.setState({
                    'job_name': e.target.value
                })}
                />
              </Col></Row>
              <Button
                color='primary'
                onClick={() => {
                    this.search()
                }}
              >Search</Button>
                <Row><Col><Container style={{'overflowX': 'auto'}}><Table
                    style={{
                        'width': '100px',
                        'background': '#3c3c3c',
                    }} >
                    <thead
                        style={{
                            'display': 'block'
                        }} >
                        <tr>
                            <th className="text-center label-weight"
                                style={{'minWidth': '130px'}}>File Name</th>
                            {
                                IMPERFECTIONS.map((x) => 
                                    <th className="text-center label-weight"
                                        style={{'minWidth': '150px'}}>{x.display_name}</th>
                                )
                            }
                            <th className="text-center label-weight"
                                style={{'minWidth': '150px'}}>Start Time</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '150px'}}>Machine</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '150px'}}>Operator</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '150px'}}>Machine Time</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '130px'}}>Humidity</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '130px'}}>Air Quality</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '130px'}}>Pressure</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '130px'}}>Temperature</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '150px'}}>Height</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '150px'}}>Width</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '150px'}}>Version</th>
                            {
                                this.state.tool_numbers.map(
                                    (toolNumber) => <>
                                        <th className="text-center label-weight"
                                            style={{'minWidth': '150px'}}>Tool {toolNumber} Feed Rate Hours</th>
                                        <th className="text-center label-weight"
                                            style={{'minWidth': '150px'}}>Tool {toolNumber} Length</th>
                                    </>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody
                        style={{
                            'display': 'block',
                            'maxHeight': '500px',
                            'overflowY': 'auto',
                            'overflowX': 'hidden',
                        }}
                    >
                        {this.makeRows()}
                    </tbody>
                </Table></Container></Col></Row>
                <Button
                    color='success'
                    onClick={() => {
                        this.updatePlates()
                    }}
                >Update</Button>
                {v ?
                <Row>
                <Col>
                    <Label style={{'bold': '500'}}>Total: </Label>
                    <Label style={{'bold': '500'}}>${v.totalPrice.toFixed(2)}</Label>
                    <br/>
                    <Label style={{'bold': '500'}}>Hours: </Label>
                    <Label style={{'bold': '500'}}>{(v.time / 60.0).toFixed(2)} hours</Label>
                    <br/>
                    <Label style={{'bold': '500'}}>Mean: </Label>
                    <Label style={{'bold': '500'}}>${(v.averagePrice * 60).toFixed(2)}/hour</Label>
                </Col>
                </Row>
                :<></>
                }
            </Container>
        )
    }
}

export default ImperfectionAdderViewController

